import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';
import { ContactPage, prefetchContactPage } from './-components/contact/page';
import { DEFAULT_NGO_TAB, parseAudience, parseTab } from './-components/contact/audiences';

/**
 * Reads the CHILD's param so the shell owns the whole page. `strict: false` because the chooser has no
 * `$audience`, and `parseAudience` nulls anything but the four, so a hand-typed segment reaches none.
 */
export const Route = createFileRoute('/www/contact')({
	loader: ({ context }) => prefetchContactPage(context),
	component: Component,
});

function Component() {
	const { audience, tab } = useParams({ strict: false });
	const parsed = parseAudience(audience);

	return (
		// From the URL alone, so the server and the client render the same panel.
		<ContactPage audience={parsed} tab={parseTab(parsed, tab) ?? DEFAULT_NGO_TAB}>
			<Outlet />
		</ContactPage>
	);
}
